<svg
  data-testid="checkmark-icon"
  xmlns="http://www.w3.org/2000/svg"
  height="100%"
  width="100%"
  viewBox="0 0 18 14"
  fill="none"
>
  <path
    d="M17 1.75L6 12.75L1 7.75"
    stroke="currentcolor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
